import pasaLogo from '~assets/pasa.svg';
const CONFIGURATION = {
    name: 'Pasa',
    key: 'crypto',
    motto: 'Verifiable Crypto Flows',
    logo: pasaLogo,
    linkPrivacyPolicy: 'https://unbounded.network/privacy',
    linkTermsOfUse: 'https://unbounded.network/terms',
};
export default CONFIGURATION;
